
import { Navigate } from "react-router-dom";
import useProfileStore from "../../store/patient/profileStore";
import { findSiglePatient } from "../../utils/patients/findSinglePatient";
import { useState } from "react";
import apiClient from "../../utils/config/apiClient";
import { updatePatient } from "../../utils/patients/updatePatient";
import { identity } from "@fullcalendar/core/internal";
import { toast } from "sonner";
import Avatar from "../../components/Avatar";
import { resetPassword } from "../../utils/patients/resetPassword";


const useManagePatient = () => {
  const user = window.localStorage.getItem("token");
  const token = user;
  
  const { profile, saveprofile} = useProfileStore();
  const [imageUrl, setImageUrl] = useState();
  const [openModal, setOpenModal] = useState({
    modalName: "",
    showModal: false,
  });
  const [rowData, setRowData] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  
  // const [token, setToken] = useState("");
  const [loading, setLoading] = useState(false);
  const [currentUser, setCurrentUser] = useState();
  const {profile:localUser} = useProfileStore()
  const [responseData, setResponseData] = useState();
//   const [formData, setFormData] = useState({
//     firstName: "",
//     lastName: "",
//     middleName: "",
//     emailAddress: "",
//     phoneNumber: "",
//     password: "",
//     confirmPassword: "",
//     children: [],
//   });

  // const closeModal = () => {
  //   setOpenModal({ modalName: "", showModal: false });
  //   setFormData({
  //     firstName: "",
  //     lastName: "",
  //     middleName: "",
  //     emailAddress: "",
  //     phoneNumber: "",
  //     password: "",
  //     confirmPassword: "",
  //     children: [],
  //   })
  // };
  
  const data = {
    // avatar:responseData?.url,
    id:profile?.id,
    enroll: 0,
    "surname":profile?.surname,
    "other_names":profile?.other_names,
    "email":profile?.email,
    "date_of_birth":profile?.date_of_birth,
    "gender":profile?.gender,
    "maritalStatus":profile?.maritalStatus,
    "hmo_id":profile?.hmo?.id,
    "address":profile?.address,
    "phone_number":profile?.phone_number,
    "ethnicity":profile?.ethnicity,
    "nok_surname":profile?.nok_surname,
    "nok_other_names":profile?.nok_other_names,
    "nok_date_of_birth":profile?.nok_date_of_birth,
    "nok_gender":profile?.nok_gender,
    "nok_maritalStatus":profile?.nok_maritalStatus,
    "nok_ethnicity":profile?.nok_ethnicity,
    "nok_relationship":profile?.nok_relationship,
    "nok_address":profile?.nok_address,
    "nok_phoneNumber":profile?.nok_phoneNumber,
    "nok_email":profile?.nok_email,
    "is_staff":profile?.is_staff,
    "is_mother":profile?.is_mother,
    "staff_id":profile?.staff_id,
    "mother_id":profile?.mother_id,
    "enrollee_id":profile?.enrollee_id,
    "sign":profile?.sign,
    "service_id":profile?.service_id
  }


  const handleImageUpload = async (file) => {
    if (!file) {
      toast.error("Please select a picture first.");
      return;
    }
  
    const formData = new FormData();
    formData.append("file", file);
  
    try {
      setLoading(true);
      const response = await apiClient.post("/public/portal?url=patient/upload-avatar", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: "Bearer " + token,
        },
      });

      const data = response?.data || {};
      const avatarLink = data?.link || data?.imageUrl || data?.url;

      if (!avatarLink) {
        throw new Error("Avatar upload response did not include an image link.");
      }

      setImageUrl(avatarLink);
      setResponseData(data);
      await updateProfile(avatarLink);

      return avatarLink;
    } catch (error) {
      console.error("Wahala for image upload:", error);
      toast.error("Profile image upload failed.");
      throw error;
    } finally {
      setLoading(false);
    }
  };
  // const findPatient = async (data) => {
  //   setLoading(true);
  //   await findSiglePatient(profile?.id)
  //   .then((res) => {
  //       setLoading(false);
  //       setCurrentUser(...res?.data);
  //       saveprofile(...res?.data);
  //     })
  //     .catch((err) => {
  //       setLoading(false);
  //       window.location.href = "/pages/signin2";
  //       console.log("error error");
  //       localStorage?.setItem("user", null)
  //     });
  // };
  const findPatient = async () => {
    if (!profile?.id) return;
    setLoading(true);
    try {
      const res = await findSiglePatient(profile.id);
      if (res?.data && Array.isArray(res.data) && res.data.length > 0) {
        setCurrentUser(res.data[0]);
        saveprofile(res.data[0]);
      }
    } catch (err) {
      console.error("Error fetching patient:", err);
      if (err?.response?.status === 401) {
        localStorage.removeItem("user");
        localStorage.removeItem("token");
        window.location.href = "/pages/signin2";
      }
    } finally {
      setLoading(false);
    }
  };

  const findPatientAlt = async (ref) => {
    if (!ref) return;
    setLoading(true);
    try {
      const res = await findSiglePatient(ref);
      if (res?.data && Array.isArray(res.data) && res.data.length > 0) {
        setCurrentUser(res.data[0]);
        saveprofile(res.data[0]);
      }
    } catch (err) {
      console.error("Error fetching patient:", err);
      if (err?.response?.status === 401) {
        localStorage.removeItem("user");
        localStorage.removeItem("token");
        window.location.href = "/pages/signin2";
      }
    } finally {
      setLoading(false);
    }
  };
  
  const resetPatientPassword = async (data) => {
    if (!data) return;
    setLoading(true);
    try {
      const res = await resetPassword(data);
      // setCurrentUser(...res?.data);
      // saveprofile(...res?.data);
      toast.success("Password Reset Successfully")
    } catch (err) {
      console.error("Error fetching patient:", err);
      // localStorage.removeItem("user");
      localStorage?.setItem("user", null)
      window.location.href = "/pages/signin2";
      window.location.href = "/pages/signin2";
    } finally {
      setLoading(false);
    }
  };
  




 const updateProfile = async (e) =>{
  const newData = {
    avatar:e,
    ...data
  }
  setLoading(true);
    await updatePatient(newData)
    .then((res) => {
        setLoading(false);
        // setCurrentUser(...res?.data);
        // saveprofile(...res?.data);
        findPatient(profile?.id)
        toast.success("Profile Updated")
        setLoading(false)
      })
      .catch((err) => {
        setLoading(false);
        window.location.href = "/pages/signin2";
        console.log("error error");
        localStorage?.setItem("user", null)
      });
 } 


  return {
    openModal,
    setOpenModal,
    rowData,
    setRowData,
    findPatientAlt,
    loading,
    currentUser,
    handleImageUpload,
    resetPatientPassword,
    setCurrentUser,
    responseData,
    setResponseData,
    findPatient,
  };
};

export default useManagePatient;
